import FilterRegister from "../../../../components/filter/register-basic";
import reqTaxaEntrega from "../../../../services/reqMultiTenant/reqTaxaEntrega";
import { RegisterProvider } from "../../register-matrix/context-api";
import MainRegisterMatrix from "../../register-matrix/main";
import Form from "../form";

const MainRegisterDeliveryFee = () => {
	const identForm = "delivery-fee";
	const options = {
		id: "id_taxa_entrega",
		ident: `register${identForm}`,
		identFilter: `filter${identForm}`,
		title: "Taxas de Entrega",
		subTitle: "Cadastro",
		notice: "Como interpretar: cada linha representa a taxa cobrada até a distância cadastrada. Exemplo: Distância 4KM / Valor R$ 3,00 → entregas de até 4 km custam R$ 3,00.",
		tableColumns: [
			{ key: "distancia", label: "Distância Max. (km)", align: "left" },
			{ key: "valor", label: "Taxa (R$)", align: "left", format: "currency" },
			{ key: "ativo", label: "Ativo", align: "center", format: "badgeAtivoSoft" },
			{ key: "actions", label: "", align: "right" },
		],
		hasActive: true,
		parametersFilter: [{ id: 1, label: "Distância Máxima (km)", value: "distancia" }],
	};

	const formatData = (item) => {
		if (!item) return item;
		return {
			...item,
			id_taxa_entrega: item.id_taxa_entrega || item.ID_TAXA_ENTREGA,
		};
	};

	const fetch = async (filterData, newPage) => {
		const { param, paramValue, active } = filterData;
		const response = await reqTaxaEntrega.list(param, paramValue, active, newPage);

		if (response && response.data && Array.isArray(response.data)) {
			response.data = response.data.map(formatData);
		}

		return response;
	};

	const fetchID = async (currentId) => {
		const response = await reqTaxaEntrega.listID(currentId);

		if (response && response.data) {
			const record = Array.isArray(response.data) ? response.data[0] : response.data;
			response.data = formatData(record);
		}

		return response;
	};

	const insert = async (data) => {
		return await reqTaxaEntrega.insert(data);
	};

	return (
		<RegisterProvider options={options} fetch={fetch} fetchID={fetchID} insert={insert}>
			<MainRegisterMatrix FormComponent={Form} FormFilter={FilterRegister} />
		</RegisterProvider>
	);
};

export default MainRegisterDeliveryFee;
